import React from 'react';
import { BrowserRouter as Router, Routes, Route, Outlet, useLocation } from 'react-router-dom';
import Navbar from './components/roar/Navbar';
import Footer from './components/roar/Footer';
import HomePage from './components/roar/HomePage';
import RoarAboutPage from './components/roar/RoarAboutPage';
import RobotPage from './components/roar/RobotPage';
import SponsorsPage from './components/roar/SponsorsPage';
import ContactPage from './components/roar/ContactPage';
import JoinPage from './components/JoinPage';
import FTCHero from './components/FTCHero';
import FRCHero from './components/FRCHero';
import FTCPage from './components/FTCPage';
import FTCRobotPage from './components/FTCRobotPage';
import FTCAchievementsPage from './components/FTCAchievementsPage';
import FRCAchievementsPage from './components/FRCAchievementsPage';
import TeamPage from './components/TeamPage';
import ComingSoonPage from './components/ComingSoonPage';
import DashboardLayout from './components/Dashboard/DashboardLayout';
import DashboardHome from './components/Dashboard/DashboardHome';
import LoginPage from './components/Dashboard/LoginPage';
import InventoryModule from './components/Dashboard/InventoryModule';
import TasksModule from './components/Dashboard/TasksModule';
import CalendarModule from './components/Dashboard/CalendarModule';
import { AuthProvider } from './components/Dashboard/AuthContext';
import PageTransition from './components/PageTransition';

function AppRoutes() {
  return (
    <PageTransition>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<RoarAboutPage />} />
        <Route path="/robot" element={<RobotPage />} />
        <Route path="/robots" element={<RobotPage />} />
        <Route path="/sponsors" element={<SponsorsPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/join" element={<JoinPage />} />

        <Route path="/ftc" element={
          <>
            <FTCHero />
            <FTCPage />
          </>
        } />
        <Route path="/ftc/robot" element={<FTCRobotPage />} />
        <Route path="/ftc/team" element={<TeamPage />} />
        <Route path="/ftc/achievements" element={<FTCAchievementsPage />} />

        <Route path="/frc" element={
          <>
            <FRCHero />
            <div style={{ padding: 'var(--section-y) var(--gutter)', maxWidth: 'var(--content-max)', margin: '0 auto' }}>
              <h2 style={{ fontFamily: 'var(--font-display)', fontSize: 'var(--text-3xl)' }}>FRC Division</h2>
              <p style={{ color: 'var(--color-text-muted)', fontSize: 'var(--text-lg)', lineHeight: 1.7 }}>
                More content coming soon.
              </p>
            </div>
          </>
        } />
        <Route path="/frc/achievements" element={<FRCAchievementsPage />} />
        <Route path="/frc/robot" element={
          <ComingSoonPage
            title="FRC Robot"
            description="Our FRC robot page is coming soon. Check back after our first build season!"
            backLink="/frc"
            backLinkText="Back to FRC"
          />
        } />
        <Route path="/frc/build-season" element={
          <ComingSoonPage
            title="Build Season"
            description="Follow our FRC build season progress. Content coming after our first competition season!"
            backLink="/frc"
            backLinkText="Back to FRC"
          />
        } />
        <Route path="/frc/sponsors" element={
          <ComingSoonPage
            title="FRC Sponsors"
            description="Thank you to our FRC sponsors! This page will be updated soon."
            backLink="/frc"
            backLinkText="Back to FRC"
          />
        } />
        <Route path="/frc/team" element={
          <ComingSoonPage
            title="FRC Team"
            description="Meet our FRC team members. This page will be updated as we build our FRC program."
            backLink="/frc"
            backLinkText="Back to FRC"
          />
        } />
        <Route path="/frc/media" element={
          <ComingSoonPage
            title="FRC Media"
            description="Photos and videos from our FRC competitions and build season. Coming soon!"
            backLink="/frc"
            backLinkText="Back to FRC"
          />
        } />

        <Route path="/outreach" element={
          <div className="roar-page" style={{ padding: 'var(--section-y) var(--gutter)', minHeight: '50vh' }}>
            <h1 style={{ fontFamily: 'var(--font-display)', fontSize: 'var(--text-4xl)' }}>Outreach</h1>
            <p style={{ color: 'var(--color-text-muted)', marginTop: 'var(--space-4)' }}>Content coming soon.</p>
          </div>
        } />

        <Route path="/dashboard" element={<AuthProvider><Outlet /></AuthProvider>}>
          <Route path="login" element={<LoginPage />} />
          <Route element={<DashboardLayout />}>
            <Route index element={<DashboardHome />} />
            <Route path="inventory" element={<InventoryModule />} />
            <Route path="tasks" element={<TasksModule />} />
            <Route path="calendar" element={<CalendarModule />} />
            <Route path="roles" element={<div style={{ padding: 'var(--space-8)' }}><h2>Roles Module - Coming Soon</h2></div>} />
            <Route path="settings" element={<div style={{ padding: 'var(--space-8)' }}><h2>Settings - Coming Soon</h2></div>} />
          </Route>
        </Route>
      </Routes>
    </PageTransition>
  );
}

function AppShell() {
  const { pathname } = useLocation();
  const isDashboard = pathname.startsWith('/dashboard');

  return (
    <div className="App">
      {!isDashboard && <Navbar />}
      <AppRoutes />
      {!isDashboard && <Footer />}
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppShell />
    </Router>
  );
}

export default App;
